import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'dva';
import styles from './TabBar.module.scss';

function TabBar(props) {

  let tabs = [];
  let index = 1;

  for ( const key in props.tabBarItems ) {
    const tabBarItem = props.tabBarItems[key];
    tabs.push(
      <span
        key={index++}
        className={`${styles.tabBarItem} ${tabBarItem.disabled === true ? styles.tabBarItemDisabled : ''} ${props.tab === key ? styles.tabBarItemSelected : ''}`}
        onClick={tabBarItem.onClick}
      >{tabBarItem.title}</span>
    );
  }

  return (
    <div className={styles.container}>
      {tabs}
    </div>
  );
}

TabBar.propTypes = {
  tabBarItems: PropTypes.object,
  tab: PropTypes.string,
};

export default TabBar;